import Vue from 'vue'
import Router from 'vue-router'

import Map from '../components/Map'
import SHLB from '../components/SHLB'

Vue.use(Router);

export default new Router({
    mode: 'history',
    routes: [
        {
            path: '/',
            name: 'Map',
            component: Map
        },
        {
            path: '/shlb',
            name: 'SHLB',
            component: SHLB
        }
    ]
})



// WEBPACK FOOTER //
// ./src/router/index.js